import React, {useEffect, useState} from 'react';
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {
    Box, Chip, CircularProgress,
    Typography
} from "@mui/material";
import {ImportAmortizationService} from "../../../services/import-integration-routines-service";
import {ErrorComponent} from "../../../components/error/error.component";
import {
    ExecutionLogRfc,
    IntegrationRoutineStatus,
    mapStatusColor,
    mapStatusString
} from "../../../models/basic/integration-routines";
import {translate} from "../../../translate/translate";

function ExecutionLogRfcComponent(props: any) {

    const {
        openDialog,
        handleCloseDialog,
        rfc,
    } = props;

    const service = new ImportAmortizationService()
    const [logDetails, setLogDetails] = useState<ExecutionLogRfc>(new ExecutionLogRfc());
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (rfc && openDialog) {
            loadLogDetails(rfc.id);
        }
    }, [rfc]);

    const loadLogDetails = (id: number) => {
        setLoading(true);
        service.getLogs(id).then((response) => {
            setLogDetails(response.data)

        }).catch((error) => {
            ErrorComponent(error);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <GenericDialog
            maxWidth="md"
            open={openDialog}
            onClose={() => {
                handleCloseDialog();
            }}
            title={"Log de Execução"}
            hideConfirmButton={true}
            closeButtonText="close"
            colorButton={"primary"}>
            {!loading && !!rfc ? (
                <>
                    <Box display="flex" flexDirection="row" marginBottom="5px">
                        <Typography variant="body1" fontWeight="bold" marginRight="5px">RFC:</Typography>
                        <Typography variant="body1">{logDetails.description || '-'}</Typography>
                    </Box>

                    <Box display="flex" flexDirection="row" marginBottom="5px">
                        <Typography variant="body1" fontWeight="bold" marginRight="5px">Parâmetros:</Typography>
                        <Typography variant="body1">{logDetails.request_parameters || '-'}</Typography>
                    </Box>

                    <Box display="flex" flexDirection="row" marginBottom="5px">
                        <Typography variant="body1" fontWeight="bold" marginRight="5px">Status:</Typography>
                        <Typography variant="body1">
                            {rfc.status !== '-' ? (
                                <Chip size="small"
                                      color={mapStatusColor[rfc.status as IntegrationRoutineStatus] as any}
                                      label={translate.t(mapStatusString[rfc.status as IntegrationRoutineStatus])}
                                />
                            ) : (
                                '-'
                            )}
                        </Typography>
                    </Box>

                    <Box display="flex" flexDirection="row" marginBottom="5px">
                        <Typography variant="body1" fontWeight="bold" marginRight="5px">Registros processados:</Typography>
                        <Typography variant="body1">{logDetails.total_imported}</Typography>
                    </Box>

                    <Box display="flex" flexDirection="row" marginBottom="5px">
                        <Typography variant="body1" fontWeight="bold" marginRight="5px">Tempo de processamento:</Typography>
                        <Typography variant="body1">{logDetails.process_time}</Typography>
                    </Box>

                    <Box display="flex" flexDirection="row" marginBottom="5px">
                        <Typography variant="body1" fontWeight="bold" marginRight="5px">Mensagem:</Typography>
                        <Typography variant="body1">{logDetails.problems_occurred || '-'}</Typography>
                    </Box>

                    <Box display="flex" flexDirection="row" marginBottom="5px">
                        <Typography variant="body1" fontWeight="bold" marginRight="5px">Executado:</Typography>
                        <Typography variant="body1">{logDetails.user || '-'}</Typography>
                    </Box>
                </>
            ) : (
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100px'}}>
                    <CircularProgress sx={{marginLeft: '10px'}} size="40px" />
                </Box>
            )}
        </GenericDialog>
    );
}

export default ExecutionLogRfcComponent;
